export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["DRAWER_MINI"] = "drawerMini";
    LocalStorageKeys["NOTES"] = "notes";
    LocalStorageKeys["LESSON_HOMEWORK"] = "lHomework";
    LocalStorageKeys["LESSON_NOTES"] = "lNotes";
    LocalStorageKeys["WHAT_IS_NEW_VERSION"] = "wIsNewVer";
})(LocalStorageKeys || (LocalStorageKeys = {}));
